import CustomAxios from "..";

export const getMediaSource = async () => {
  try {
    const response = await CustomAxios.get(`upload/uploads/files`);

    return response.data;
  } catch (error) {
    console.error("Error fetching plan:", error.message || error);
    throw new Error("Failed to retrieve the plan. Please try again.");
  }
};

export const deleteFile = async (id) => {
  try {
    const response = await CustomAxios.delete(`upload/file/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching plan:", error.message || error);
    throw new Error("Failed to retrieve the plan. Please try again.");
  }
}

